import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

type Props = {
  drama: Drama;
  rank?: number;
  compact?: boolean;
};

export default function DramaCard({ drama, rank, compact = false }: Props) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors hover:border-primary-400/70">
      <Link to={`/drama/${drama.id}`} className="block cursor-pointer" aria-label={`查看 ${drama.title} 详情`}>
        <div className="relative w-full" style={{ aspectRatio: "3 / 4" }}>
          <img
            src={drama.cover}
            alt={`${drama.title} 短剧封面海报`}
            title={`${drama.title} 剧集封面`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent"></div>

          {typeof rank === "number" && (
            <span className="absolute left-3 top-3 flex h-8 min-w-8 items-center justify-center rounded-md bg-accent-500 px-2 font-heading text-base font-bold text-background-950">
              {rank}
            </span>
          )}

          <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-background-50/80 px-2 py-1 text-xs font-label text-accent-400 backdrop-blur">
            <i className="ri-star-fill" aria-hidden="true"></i>
            {drama.rating.toFixed(1)}
          </span>

          <span className="absolute bottom-3 left-3 flex items-center gap-1 rounded-md bg-primary-500/90 px-2 py-1 text-xs font-label text-background-950">
            <i className="ri-fire-line" aria-hidden="true"></i>
            热度 {drama.heat}
          </span>
        </div>
      </Link>

      <div className={`flex flex-1 flex-col ${compact ? "p-3" : "p-4"}`}>
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-label text-accent-400">
            {drama.category}
          </span>
          <span className="rounded-full border border-background-300/60 px-2.5 py-0.5 text-[11px] font-label text-foreground-600">
            {drama.status}
          </span>
        </div>

        <h3 className={`mt-3 font-heading font-bold leading-snug text-foreground-950 ${compact ? "text-sm" : "text-base"}`}>
          <Link to={`/drama/${drama.id}`} className="cursor-pointer transition-colors hover:text-primary-400">
            {drama.title}
          </Link>
        </h3>

        {!compact && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{drama.subtitle}</p>
        )}

        <div className="mt-3 flex items-center justify-between text-[11px] font-label text-foreground-500">
          <span>{drama.episodes} 集</span>
          <span>{drama.year}</span>
        </div>
      </div>
    </article>
  );
}